/**
 * Copyright (C) 2023 Spanning Cloud Apps.  All rights reserved.
 */
import './userdropdown.tpl.html';

/**
 * Module for the User Dropdown Menu
 */
angular
  .module('shared.userdropdown', [])
  .controller('userdropdownCtrl', function ($scope, accountUtils, authFactory) {
    const logoutItem = {
      type: 'MENU_ITEM',
      text: 'SIGN_OUT'
    };

    $scope.data = $scope.data || {};
    $scope.data.dropdown = [logoutItem];

    $scope.userDropdownIconCls = {
      'default-user-dropdown-icon': true,
      'user-dropdown-icon': true
    };

    // Load the user name and image for the top level of the dropdown.
    $scope.loadUserData = function () {
      authFactory.getSignedRequest().then((user) => {
        $scope.data.dropdown = [
          {
            fullName: user.displayName || user.username,
            email: user.email !== user.username ? user.email : '',
            type: 'PROFILE'
          },
          logoutItem
        ];
        $scope.givenName = user.username;
      });
    };

    $scope.getUserNameLabel = function () {
      return $scope.givenName && $scope.givenName.split('.')[0];
    };

    $scope.logout = () => {
      return accountUtils.logout();
    };

    $scope.loadUserData();
  })
  /**
   * The directive for the userdropdown.
   */
  .directive('userdropdown', function () {
    return {
      templateUrl: 'shared/userdropdown/userdropdown.tpl.html',
      scope: {
        onShowHide: '&showhide'
      },
      controller: 'userdropdownCtrl'
    };
  });
